import { twMerge } from 'tailwind-merge';
import * as React from 'react';

export const FieldWrapper = (props) => {
  const {
    label,
    className,
    error,
    children,
    wrapperClassName,
    errorClassName,
  } = props;
  return (
    <div className="w-full">
      <label
        style={{ lineHeight: '22px', bottom: error?.message ? '1.5rem' : '0' }}
        className={twMerge('block text-sm text-gray-700', className)}
      >
        {label}
        <div className={`w-full ${wrapperClassName}`}>{children}</div>
      </label>
      {error?.message && (
        <div
          role="alert"
          aria-label={error.message}
          className={twMerge(
            'text-xs font-normal text-red-500',
            errorClassName
          )}
        >
          {error.message}
        </div>
      )}
    </div>
  );
};
